import { request } from "../../../services/api"
import type { BaseApiResponse } from "../../../types/api.ts"
import type {
  InvoiceData,
  InvoiceFilterOptions,
  InvoiceFilterOptionsParams,
  InvoicePatchData,
  InvoiceResponse,
  InvoiceSnapshotResponse,
  InvoiceUpdateData,
  InvoicesParams,
  InvoicesResponse
} from "./services.types.ts"

const BASE_URL = `/project-management/invoices`

const PATHS = {
  getInvoices: `${BASE_URL}/`,
  exportInvoices: `${BASE_URL}/export/`,
  createInvoice: `${BASE_URL}/`,
  getInvoicesFilterOptions: `${BASE_URL}/filter_options/`,
  getInvoice: (id: string) => `${BASE_URL}/${id}/`,
  updateInvoice: (id: string) => `${BASE_URL}/${id}/`,
  patchInvoice: (id: string) => `${BASE_URL}/${id}/`,
  deleteInvoice: (id: string) => `${BASE_URL}/${id}/`,
  getInvoiceSnapshot: (id: string) =>
    `/project-management/projects/${id}/invoice-snapshot/`
}

export const getInvoices = async (params: InvoicesParams) => {
  return request.api.get<InvoicesResponse, BaseApiResponse<unknown>>(
    PATHS.getInvoices,
    params
  )
}

export const exportInvoices = async (projectId: string) => {
  return request.api.get<Blob, BaseApiResponse<unknown>>(
    PATHS.exportInvoices,
    { project: projectId },
    { responseType: "blob" }
  )
}

export const createInvoice = async (data: InvoiceData) => {
  return request.api.post<
    BaseApiResponse<InvoiceResponse>,
    BaseApiResponse<unknown>
  >(PATHS.createInvoice, data)
}

export const getInvoicesFilterOptions = async (
  params: InvoiceFilterOptionsParams
) => {
  return request.api.get<InvoiceFilterOptions, BaseApiResponse<unknown>>(
    PATHS.getInvoicesFilterOptions,
    params
  )
}

export const getInvoice = async (id: string) => {
  return request.api.get<InvoiceResponse, BaseApiResponse<unknown>>(
    PATHS.getInvoice(id)
  )
}

export const updateInvoice = async (id: string, data: InvoiceUpdateData) => {
  return request.api.put<
    BaseApiResponse<InvoiceResponse>,
    BaseApiResponse<unknown>
  >(PATHS.updateInvoice(id), data)
}

export const patchInvoice = async ({ id, ...data }: InvoicePatchData) => {
  return request.api.patch<
    BaseApiResponse<InvoiceResponse>,
    BaseApiResponse<unknown>
  >(PATHS.patchInvoice(id), data)
}

export const deleteInvoice = async (id: string) => {
  return request.api.delete<BaseApiResponse<unknown>, BaseApiResponse<unknown>>(
    PATHS.deleteInvoice(id)
  )
}

export const getInvoiceSnapshot = async (id: string) => {
  return request.api.get<InvoiceSnapshotResponse, BaseApiResponse<unknown>>(
    PATHS.getInvoiceSnapshot(id)
  )
}
